const PT = require("prop-types");
const React = require("react");
const _ = require("lodash");
const createReactClass = require("create-react-class");

const withOfficeErrorCatching = require("../core/hoc/withOfficeErrorCatching");
const withVaultDispatch = require("../core/hoc/withVaultDispatch");
const withVaultUpdate = require("../core/hoc/withVaultUpdate");
const AT = require("../core/vault/ActionTypes");
const Slots = require("../core/vault/Slots");
const LoadGuard = require("../core/view/LoadGuard");
const ReportClassStudents = require("./ReportClassStudents");

const styles = require("./styles/ReportBody.css");

// Helper to apply higher-order components.
const augment = function(Component) {
	Component = withOfficeErrorCatching(Component);
	Component = withVaultDispatch(Component);
	Component = withVaultUpdate(
		Component,
		(props, vaultState) => {
			return {
				students: Slots.getValue(vaultState, Slots.table.reportStudents()),
			};
		},
		{forLoggedIn: true}
	);
	return Component;
};

module.exports = augment(
	createReactClass({
		displayName: "PageClassReports",

		propTypes: {
			user: PT.object.isRequired,
			pageData: PT.object,
			classID: PT.number,

			// Injected by HOCs
			dispatch: PT.func.isRequired,
			students: PT.object.isRequired,
		},

		loadStudents: function() {
			this.props.dispatch({
				type: AT.LOAD_REPORT_STUDENTS_PRINT_SLOT_REQUEST,
				classID: this.props.pageData.classID,
			});
		},

		renderStudents: function() {
			const {students, pageData, user} = this.props;
			const studentsData = students.overall;
			const studentIDs = _.uniq(_.map(studentsData, s => s.userID));
			const {block, chapter, grade, classID, typeID} = pageData;
			return (
				<ReportClassStudents
					studentIDs={studentIDs}
					gradeNumber={grade}
					chapterNumber={chapter}
					blockNumber={block}
					typeID={typeID}
					classID={classID}
					user={user}
					pageData={pageData}
					studentsData={_.keyBy(studentsData, s => s.userID)}
				/>
			);
		},

		render: function() {
			const {students} = this.props;

			return (
				<div className={styles.main}>
					<LoadGuard
						identifier="reportStudents"
						status={students}
						requestLoad={this.loadStudents}
						loadingView={"logo"}
						logoColorType={"white"}
						loadingViewClass={styles.loading}
						errorView="refreshOffice"
						renderLoaded={this.renderStudents}
					/>
				</div>
			);
		},
	})
);
